module.exports = __webpack_public_path__ + "img/stripes.4a32620.svg";